import React from 'react';
import { useNavigate } from 'react-router-dom';
import Navbar from '../components/Navbar';
import Footer from '../components/Footer';
import { Helmet } from 'react-helmet';
import '../styles/SubjectsPage.css';

const SubjectsPage = () => {
  const navigate = useNavigate();

  const subjects = [
    {
      id: 'all',
      name: 'सर्व प्रश्नसंच',
      nameEnglish: 'All Quizzes',
      icon: '📚',
      color: 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)',
      apiSubject: 'all',
      description: 'सर्व उपलब्ध प्रश्नसंच पहा'
    },
    {
      id: 'geography',
      name: 'भूगोल',
      nameEnglish: 'Geography',
      icon: '🌍',
      color: 'linear-gradient(135deg, #f093fb 0%, #f5576c 100%)',
      apiSubject: 'Geography',
      description: 'भौतिक आणि मानवी भूगोल'
    },
    {
      id: 'current-affairs',
      name: 'चालू घडामोडी',
      nameEnglish: 'Current Affairs',
      icon: '📰',
      color: 'linear-gradient(135deg, #4facfe 0%, #00f2fe 100%)',
      apiSubject: 'CurrentAffairs',
      description: 'ताज्या बातम्या आणि घटना'
    },
    {
      id: 'history',
      name: 'इतिहास',
      nameEnglish: 'History',
      icon: '🏛️',
      color: 'linear-gradient(135deg, #fa709a 0%, #fee140 100%)',
      apiSubject: 'History',
      description: 'प्राचीन, मध्ययुगीन आणि आधुनिक इतिहास'
    },
    {
      id: 'math-reasoning',
      name: 'गणित आणि तर्कशक्ती',
      nameEnglish: 'Math & Reasoning',
      icon: '🔢',
      color: 'linear-gradient(135deg, #30cfd0 0%, #330867 100%)',
      apiSubject: 'MathReasoning',
      description: 'गणित आणि तार्किक विचार'
    },
    {
      id: 'marathi',
      name: 'मराठी व्याकरण',
      nameEnglish: 'Marathi Grammar',
      icon: '📖',
      color: 'linear-gradient(135deg, #a8edea 0%, #fed6e3 100%)',
      apiSubject: 'MarathiGrammar',
      description: 'मराठी भाषा आणि व्याकरण'
    },
    {
      id: 'science',
      name: 'विज्ञान',
      nameEnglish: 'Science',
      icon: '🔬',
      color: 'linear-gradient(135deg, #ff9a9e 0%, #fecfef 100%)',
      apiSubject: 'Science',
      description: 'भौतिकशास्त्र, रसायनशास्त्र, जीवशास्त्र'
    },
    {
      id: 'polity',
      name: 'राज्यशास्त्र',
      nameEnglish: 'Polity',
      icon: '⚖️',
      color: 'linear-gradient(135deg, #ffecd2 0%, #fcb69f 100%)',
      apiSubject: 'Polity',
      description: 'भारतीय संविधान आणि शासन'
    },
    {
      id: 'police-bharti',
      name: 'पोलीस भरती',
      nameEnglish: 'Police Bharti',
      icon: '👮',
      color: 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)',
      apiSubject: 'PoliceBharati',
      description: 'पोलीस भरती परीक्षेची तयारी'
    },
    {
      id: 'economics',
      name: 'अर्थशास्त्र',
      nameEnglish: 'Economics',
      icon: '💰',
      color: 'linear-gradient(135deg, #a1c4fd 0%, #c2e9fb 100%)',
      apiSubject: 'Economics',
      description: 'भारतीय आणि जागतिक अर्थव्यवस्था'
    },
    {
      id: 'english',
      name: 'इंग्रजी',
      nameEnglish: 'English',
      icon: '🔤',
      color: 'linear-gradient(135deg, #fbc2eb 0%, #a6c1ee 100%)',
      apiSubject: 'English',
      description: 'इंग्रजी व्याकरण आणि आकलन'
    },
    {
      id: 'computer-it',
      name: 'संगणक आणि आयटी',
      nameEnglish: 'Computer & IT',
      icon: '💻',
      color: 'linear-gradient(135deg, #84fab0 0%, #8fd3f4 100%)',
      apiSubject: 'ComputerIT',
      description: 'संगणक विज्ञान आणि माहिती तंत्रज्ञान'
    },
    {
      id: 'banking',
      name: 'बँकिंग परीक्षा',
      nameEnglish: 'Banking Exams',
      icon: '🏦',
      color: 'linear-gradient(135deg, #fa709a 0%, #fee140 100%)',
      apiSubject: 'BankingExams',
      description: 'बँकिंग क्षेत्रातील परीक्षांची तयारी'
    },
    {
      id: 'government-jobs',
      name: 'सरकारी नोकऱ्या',
      nameEnglish: 'Government Jobs',
      icon: '🏛️',
      color: 'linear-gradient(135deg, #f093fb 0%, #f5576c 100%)',
      apiSubject: 'GovernmentJobs',
      description: 'सरकारी नोकरीची तयारी'
    },
    {
      id: 'general-knowledge',
      name: 'सामान्य ज्ञान',
      nameEnglish: 'General Knowledge',
      icon: '📚',
      color: 'linear-gradient(135deg, #4facfe 0%, #00f2fe 100%)',
      apiSubject: 'GeneralKnowledge',
      description: 'सामान्य ज्ञान आणि जागरूकता'
    },
    {
      id: 'other',
      name: 'इतर विषय',
      nameEnglish: 'Other Topics',
      icon: '📝',
      color: 'linear-gradient(135deg, #d299c2 0%, #fef9d7 100%)',
      apiSubject: 'Other',
      description: 'विविध विषय'
    }
  ];

  const handleSubjectClick = (subject) => {
    navigate(`/quizzes/${subject.id}`, { 
      state: { 
        subjectName: subject.name,
        subjectNameEnglish: subject.nameEnglish,
        apiSubject: subject.apiSubject
      } 
    });
  };

  return (
    <div className="subjects-page">
      <Helmet>
        <title>एमपीएससी विषय - मोफत चाचणी मालिका | स्पर्धावेब</title>
        <meta name="description" content="इतिहास, भूगोल, राज्यशास्त्र, विज्ञान, गणित आणि इतर विविध एमपीएससी विषयांमधून निवडा. एमपीएससी तयारीसाठी मोफत चाचणी मालिका." />
        <meta name="keywords" content="एमपीएससी विषय, एमपीएससी चाचणी मालिका, एमपीएससी तयारी, मोफत एमपीएससी चाचण्या" />
      </Helmet>

      <Navbar />

      {/* Header Section */}
      <div className="subjects-header">
        <div className="container">
          <h1 className="subjects-heading">
            📚 तुमचा विषय निवडा
          </h1>
          <p className="subjects-description">
            आमच्या सर्वसमावेशक चाचणी मालिकेसह सराव सुरू करण्यासाठी विषय निवडा
          </p>
          <div className="subjects-stats">
            <div className="stat-item">
              <span className="stat-icon">📝</span>
              <span className="stat-value">{subjects.length - 1}</span>
              <span className="stat-label">विषय</span>
            </div>
            <div className="stat-item">
              <span className="stat-icon">🎯</span>
              <span className="stat-value">१०००+</span>
              <span className="stat-label">प्रश्न</span>
            </div>
            <div className="stat-item">
              <span className="stat-icon">✅</span>
              <span className="stat-value">मोफत</span>
              <span className="stat-label">प्रवेश</span>
            </div>
          </div>
        </div>
      </div>

      {/* Subjects Grid */}
      <div className="container subjects-container">
        <div className="subjects-grid">
          {subjects.map((subject, index) => (
            <div
              key={subject.id}
              className="subject-card"
              onClick={() => handleSubjectClick(subject)}
              style={{ 
                animationDelay: `${index * 0.1}s`,
                '--card-gradient': subject.color
              }}
            >
              <div className="subject-card-inner">
                <div className="subject-icon">{subject.icon}</div>
                <h3 className="subject-name">{subject.name}</h3>
                <p className="subject-name-english">{subject.nameEnglish}</p>
                <p className="subject-description">{subject.description}</p>
                <div className="subject-arrow">→</div>
              </div>
            </div>
          ))}
        </div>
      </div>

      {/* Info Section */}
      <div className="container info-section">
        <div className="info-card">
          <h3>🎓 विषयनिहाय सराव का करावा?</h3>
          <div className="info-grid">
            <div className="info-item">
              <span className="info-icon">🎯</span>
              <h4>केंद्रित शिक्षण</h4>
              <p>एका वेळी एक विषय मास्टर करा</p>
            </div>
            <div className="info-item">
              <span className="info-icon">📊</span>
              <h4>प्रगती ट्रॅक करा</h4>
              <p>तुमच्या सुधारणेचे निरीक्षण करा</p>
            </div>
            <div className="info-item">
              <span className="info-icon">⏰</span>
              <h4>वेळ वाचवा</h4>
              <p>तुम्हाला आवश्यक असलेल्या गोष्टींचा सराव करा</p>
            </div>
            <div className="info-item">
              <span className="info-icon">💪</span>
              <h4>आत्मविश्वास वाढवा</h4>
              <p>कमकुवत क्षेत्रे मजबूत करा</p>
            </div>
          </div>
        </div>
      </div>

      <Footer />
    </div>
  );
};

export default SubjectsPage;